import { doClearSearchResults } from 'ducks/ticketing/operations/kbSearch/articles'
import {
  selectArticles,
  selectKnowledgeBases,
} from 'ducks/ticketing/selectors/kbSearch'

export const doInsertKbLink = (articleID, knowledgeBaseId, editor) => (
  dispatch,
  getState
) => {
  const state = getState()
  const articles = selectArticles(state)
  const knowledgeBases = selectKnowledgeBases(state)
  const article = articles.find(a => a.id === articleID)
  const knowledgeBase = knowledgeBases.find(kb => kb.id === knowledgeBaseId)
  if (knowledgeBase && article) {
    // TODO: Implement this check when we've implemented the notes functionlity
    //       for the chat system
    const isNote = false
    const isActive =
      knowledgeBase.enabled && ['published', 'wip'].includes(article.state)
    const url = `${knowledgeBase.siteUrl}/${article.slug}`
    if (isActive || isNote) {
      // eslint-disable-next-line no-underscore-dangle
      editor._insertTextAtLastPosition(url)
      return doClearSearchResults()(dispatch, getState)
    }
  }
  return Promise.reject('Article is not active or doesnt exist')
}
